export const API_ENDPOINTS = {
  chat: '/api/v3/concierge/message',
  feedback: '/api/v3/concierge/feedback'
}
